/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */
import { ClassSerializerInterceptor, Logger, ValidationPipe } from '@nestjs/common';
import { NestFactory, Reflector } from '@nestjs/core';
import { AppModule } from './app/app.module';
import { createDocument } from './swagger/swagger';
import * as bodyParser from 'body-parser';

async function bootstrap() {
   const app = await NestFactory.create(AppModule);

  app.enableCors({ credentials: true, origin: true });

  const reflector = app.get(Reflector);
  app.use(bodyParser.urlencoded({ limit: '1000mb', extended: true }));
  app.use(bodyParser.json({ limit: '1000mb' }));
  app.useGlobalPipes(new ValidationPipe({ validationError: { target: false }, transform: true, forbidUnknownValues: false }));
  app.useGlobalInterceptors(new ClassSerializerInterceptor(reflector));
  createDocument(app);

  const server = await app.listen(9200);
  server.setTimeout(1000 * 600);
  Logger.log(`🚀 Needle Management service - http://localhost:${3000}`);
}

bootstrap();
